import { writable, Writable } from "svelte/store";
import type { UserContextType } from "@shared/types/User";
import { HttpPromise } from "@shared/svelte/Modules/ApiService";
import { isAdmin } from "@shared/services/internal_user_check_helpers";
import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";
import ProductTypesStore from "@shared/svelte/Stores/ProductTypesStore.js";
import * as stagedRollouts from "@shared/services/staged_rollouts";
import * as _ from "lodash";
import * as Sentry from "@sentry/browser";
import { getControlStateAuthenticationService } from "@retailer/services/retailer_user_authentications_service";

var service = function () {
  let context: UserContextType = { user: null, trueUser: null };
  let userContextStore: Writable<UserContextType>;
  if (!window["$rootScope"]) {
    window["$rootScope"] = {};
  }

  async function initialize() {
    let userRes = await load();
    await loadTrue();
    setStore();
    setSentryContext();
    // regrettable but "temporary":
    window["$rootScope"].user = context.user;
    window["$rootScope"].trueUser = context.trueUser;
    return userRes;
  }

  var userNameString = function (user) {
    if (!user) {
      return "";
    }
    var str = "";
    if (user.first_name) {
      str += user.first_name;
    }
    if (user.last_name) {
      if (str.trim().length > 0) str += " ";
      str += user.last_name;
    }

    if (str.trim().length < 1) return (user.email || "").trim();
    return str.trim();
  };

  const setProductTypesData = function (data) {
    ProductTypesStore.update(n => data);
    let sharedContext = {};
    let cachedRes = {};
    _.map(data.types, function (i) {
      cachedRes[i.id] = i;
    });

    sharedContext["productTypes"] = cachedRes;
    sharedContext["productPackagingDescriptions"] = data.product_packaging_descriptions;
    sharedContext["productContainerTypes"] = data.container_types;
    window["sharedContext"] = sharedContext;
  };

  async function load() {
    const res = await HttpPromise({
      method: "GET",
      url: window["C"].userUrl,
    });
    CurrentUserStore.update(n => res);

    context.user = res;
    let res2;
    let res3;

    if (window["C"].APP_NAME === "retailer") {
      try {
        res2 = await HttpPromise({
          method: "GET",
          url: "/api/retailer/init",
        });
      } catch (e) {
        console.error(e);
        return false;
      }
      stagedRollouts.prepareStagedRollouts(res2.staged_rollouts);
      setProductTypesData(res2.product_types);
      window["$rootScope"].numUnseenMessages = res2.num_unseen_messages;
      window["$rootScope"].policies = res2.policy;

      const retailerUserAuthRollout =
        window["$rootScope"]?.rollouts?.["marketplace__retailer_user_authentication"];

      if (retailerUserAuthRollout) {
        let authService = getControlStateAuthenticationService();
        if (authService) {
          authService.refresh();
        }
      }
    } else if (window["C"].APP_NAME === "supplier") {
      try {
        res2 = await HttpPromise({
          method: "GET",
          url: "/api/supplier/init",
        });
      } catch (e) {
        console.error(e);
        return false;
      }
      window["$rootScope"].policies = res2.policy;
      stagedRollouts.prepareStagedRollouts(res2?.staged_rollouts);
    } else if (window["C"].APP_NAME === "distributor") {
      try {
        res2 = await HttpPromise({
          method: "GET",
          url: "/api/distributor/policies",
        });
      } catch (e) {
        console.error(e);
        return false;
      }
      window["$rootScope"].policies = res2;
      try {
        res3 = await HttpPromise({
          method: "GET",
          url: "/api/distributor/user/staged_rollouts",
        });
      } catch (e) {
        console.error(e);
        return false;
      }
      stagedRollouts.prepareStagedRollouts(res3);
    }
    return true;
  }

  async function loadTrue() {
    const res = await HttpPromise({
      method: "GET",
      url: window["C"].userUrl,
      data: {
        true_user: true,
      },
    });
    context.trueUser = res;
  }

  function logout() {
    window.location.assign("/users/fully_log_out");
  }

  function setStore() {
    userContextStore = writable<UserContextType>(context);
  }

  function getStoreReference(): Writable<UserContextType> {
    return userContextStore;
  }

  function setSentryContext() {
    let userObj = {
      id: context.user?.id?.toString(),
      admin: context.user?.admin,
      true_user_id: context.trueUser?.id,
      email: context.user?.email,
    };
    Sentry.setUser(userObj);
  }

  return {
    logout,
    initialize: initialize,
    getStore: getStoreReference,
    userNameString: userNameString,
    isAdmin: isAdmin,
    context: context,
  };
};
const userContext = service();
export default userContext;
